// extracted by mini-css-extract-plugin
export default {"self":"Dashboard_self__jnhvd","content":"Dashboard_content__kKLHI","welcomeLink":"Dashboard_welcomeLink__uTxIc","welcomeText":"Dashboard_welcomeText__uOl2Y"};